<template>
  <!-- 某个产品 -->
  <div class="product-box--main">
    <h3 class="product-name f-cb">
      <span class="float_left">{{sourceData.title}}</span>
      <span v-if="showOverview"
            @click="jumpTo(sourceData, hasPackagePermission, showOverview)"
            :class="['float_left btn', hasPackagePermission ? '' : 'invalid']">
        首页
      </span>
    </h3>
    <div class="application-wrapper f-cb">
      <div class="package float_left" v-for="(item, idx) in sourceData.children" :key="'package-' + idx">
        <p v-if="item.title && !/^\d+$/.test(item.title)" class="package-title">
          {{item.title}}
        </p>
        <p class="package-title null" v-else></p>
        <div class="f-cb" v-if="item.children && item.children.length">
          <package-item v-for="(packageItem, i) in item.children"
                        :focus-application="focusApplication"
                        :item-data="packageItem"
                        @jumpToHandle="jumpTo"
                        :key="'package-item' + i">
          </package-item>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="less" type="text/less">
  .product-box--main{
    font-weight: 400;
    margin-top: 40px;
    &:first-child{
      margin-top: 0;
    }
    *{
      margin-bottom: 0;
    }
    color: #212530;
    .product-name{
      font-size: 18px;
      height: 28px;
      line-height: 28px;
      .btn{
        cursor: pointer;
        font-size: 14px;
        margin-left: 16px;
        height: 28px;
        display: inline-block;
        padding: 0 16px;
        border-radius:4px;
        color:rgba(33,37,48,0.8);
        box-sizing: border-box;
        line-height: 26px;
        border:1px solid rgb(222,223,224);
        &.invalid{
          cursor: not-allowed;
          color:rgba(33,37,48,0.35);
        }
      }
    }
    padding-bottom: 50px;
    border-bottom: 1px solid rgb(216,216,216);
    &:last-child{
      border-bottom: none;
    }
    .application-wrapper{
      .package{
        width: 50%;
        box-sizing: border-box;
        &:nth-child(odd){
          padding-right: 12px;
        }
        &:nth-child(even){
          padding-left: 12px;
        }
        .package-title{
          margin-top: 30px;
          font-weight: 500;
          font-size: 14px;
          color: #212530;
          &.null{
            margin-top: 0px;
            height: 8px;
          }
        }
        .package-item{
          width: 100px;
          margin-right: 56px;
          margin-top: 32px;
          position: relative;
          cursor: pointer;
          /*&.invalid{*/
            /*cursor: not-allowed;*/
          /*}*/
          .icon{
            display: block;
            width: 56px;
            height: 56px;
            margin:  0 auto;
            border-radius: 50%;
            overflow: hidden;
            background-color: #8c939d;
            background-size: cover!important;
            background-repeat: no-repeat!important;
          }
          .name{
            position: relative;
            color:rgba(33,37,48,0.8);
            font-weight: 400;
            height: 22px;
            line-height: 22px;
            margin-top: 16px;
            width: 100%;
            position: relative;
            font-size: 14px;
            span{
              word-break: keep-all;
              white-space: nowrap;
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
            }
          }
          .desc-box{
            visibility: hidden;
            z-index: -1;
            cursor: default;
            &.show{
              animation: dialog-fade-in-horizontal .3s;
              visibility: visible;
              z-index: 10;
            }
            background: rgb(255,255,255);
            box-shadow: 0px 2px 8px 0px rgba(33,37,48,0.2);
            border-radius: 4px;
            position: absolute;
            top: 0;
            left: 99px;
            &.left{
              left: auto;
              right: 99px;
            }
            &.bottom{
              top: auto;
              bottom: 0;
            }
            .inner{
              width: 280px;
              min-height: 255px;
              height: auto;
              box-sizing: border-box;
              padding: 24px 20px 20px 20px;
              .package-name{
                font-size: 18px;
                position: relative;
                height: 26px;
                line-height: 26px;
                .status-tips{
                  display: inline-block;
                  height: 100%;
                  font-size: 14px;
                  color: #F96753;
                  position: absolute;
                  right: 0;
                }
              }
              .slid-line{
                width: 100%;
                height: 1px;
                background:rgba(33,37,48,0.1);
                margin-top: 20px;
              }
              .desc{
                line-height:24px;
                margin-top: 20px;
                color:rgba(33,37,48,0.8);
              }
            }
          }
          /*
          &:hover{
            .desc-box{
              z-index: 10;
              visibility: visible;
            }
          }
          */
        }
      }
    }
  }
</style>
<script>
import PackageItem from './PackageItem'
import {mapState} from 'vuex'
import queryString from 'querystring'
// import {typeOf} from '@zjy/zjy-ui/lib/utils/dom'
import {clone} from '@/assets/utils'
export default {
  name: 'ProductBox',
  props: {
    sourceData: {
      type: Object,
      default: () => {}
    },
    focusApplication: {}
  },
  inject: ['rootPlatform'],
  computed: {
    ...mapState({
      applicationPermission: state => state.menus.applicationPermission
    }),
    // 1. 菜单 linkParameter 是否是 广材网 ->  广材数聚 菜单 是通过 参数里是否包含 'isIntegrationIndex' 来判断的（无法，管理后台菜单已无可用字段，需重新考虑）
    // linkParams () {
    //   let arr = []
    //   if (this.sourceData.linkParameter && typeOf(this.sourceData.linkParameter) === 'String') {
    //     arr = this.sourceData.linkParameter.split(',')
    //   }
    //   return arr
    // },
    // 1.  是否显示 “广材数聚” 旁边的 首页
    showOverview () {
      let show = false
      if (this.sourceData && this.sourceData.linkUrl && (this.sourceData.linkUrl.indexOf('overview=') > -1)) {
        show = true
      }
      return show
    },
    // 2. 是否 有查看首页（概览页）的权限
    hasPackagePermission () {
      let permission = false
      if (this.sourceData.menuName === '广材数聚') {
        // 广材网 相关的产品
        const arr = [9, 10, 11, 12, 13, 14]
        arr.forEach((val) => {
          if (this.applicationPermission[val]) {
            permission = true
          }
        })
      }
      return permission
    }
  },
  methods: {
    // 1. 某个云应用点击
    jumpTo (menu, hasPermission, showOverview) {
      //  && item.viewType === 2 && item.openType === 2
      const item = clone(menu)
      delete item.children
      delete item.childrenMenu
      delete item.gray
      let href = window.location.origin
      href += '/#/applications/iframe?' + queryString.stringify(item) + '&t=' + new Date().getTime()
      // console.dir(href)
      // console.log(item.windowName)
      this.rootPlatform.focusApplication = item.id
      if (showOverview) {
        // 点击 广材数聚 “首页” 按钮
        this.sentLog(100116001, {type: hasPermission ? 1 : 2})
      } else {
        const codeDic = {
          9: 100116002,
          10: 100116003,
          14: 100116004,
          11: 100116005,
          12: 100116006,
          13: 100116007,
          15: 100116008
        }
        this.sentLog(codeDic[menu.permissionId], {type: hasPermission ? 1 : 2})
      }
      if (hasPermission) {
        setTimeout(() => {
          window.open(href, item.windowName || '_blank')
        }, 10)
      }
    }
  },
  components: {
    PackageItem
  }
}
</script>
